'use client';

import { ReactNode } from 'react';
import Intercom from './Intercom';

interface IntercomProviderProps {
  children: ReactNode;
  appId: string;
  user?: {
    name?: string;
    email?: string;
    userId?: string;
    [key: string]: unknown;
  };
}

export default function IntercomProvider({ children, appId, user }: IntercomProviderProps) {
  return (
    <>
      {children}
      <Intercom appId={appId} user={user} />
    </>
  );
}
